export const messages = {
  en: {
    visitManage: {
      search: {
        title: 'Search Conditions',
        state: 'Select Audit Status',
        nameLike: 'Please enter visitor name',
        gender: 'Select Gender',
        phoneNumber: 'Please enter phone number',
        roomName: 'Please enter building-unit-room',
        ownerName: 'Please enter owner name',
        startTime: 'Please enter start time',
        endTime: 'Please enter end time'
      },
      list: {
        title: 'Visitor List'
      },
      table: {
        visitId: 'Visit ID',
        name: 'Name',
        photo: 'Photo',

        gender: 'Gender',
        phoneNumber: 'Phone Number',
        roomName: 'Visit Room',
        ownerName: 'Visit Owner',
        carNum: 'Visitor Car',
        visitType: 'Visit Type',
        visitCase: 'Visit Reason',
        visitTime: 'Visit Time',
        departureTime: 'Departure Time',
        state: 'Audit Status',
        msg: 'Audit Remark',
        entourage: 'Entourage',
        carStatus: 'Car Status',

        createTime: 'Create Time'
      },
      gender: {
        male: 'Male',
        female: 'Female'
      },
      visitType: 'Visit Type',
      manage: 'Manage'
    },
  },
  zh: {
    visitManage: {
      search: {
        title: '查询条件',
        state: '请选择审核状态',
        nameLike: '请输入访客姓名',
        gender: '请选择性别',
        phoneNumber: '请输入电话号码',
        roomName: '请输入拜访房屋 楼栋-单元-房屋',
        ownerName: '请输入拜访业主',
        startTime: '请输入开始时间',
        endTime: '请输入结束时间'
      },
      list: {
        title: '访客人员'
      },
      table: {
        visitId: '拜访ID',
        name: '姓名',
        photo: '照片',

        gender: '性别',
        phoneNumber: '电话号码',
        roomName: '拜访房屋',
        ownerName: '拜访业主',
        carNum: '访客车辆',
        visitType: '访客类型',
        visitCase: '拜访事由',
        entourage: '随行人数',
        visitTime: '拜访时间',
        departureTime: '离开时间',
        state: '审核状态',
        carStatus: '车辆状态',

        msg: '审核备注',
        createTime: '创建时间'
      },
      gender: {
        male: '男',
        female: '女'
      },
      visitType: '访客类型',
      manage: '管理'
    },
  },
  'zh-TW': {
    visitManage: {
      search: {
        title: '查詢條件',
        state: '請選擇審核狀態',
        nameLike: '請輸入訪客姓名',
        gender: '請選擇性別',
        phoneNumber: '請輸入電話號碼',
        roomName: '請輸入拜訪房屋 樓棟-單元-房屋',
        ownerName: '請輸入拜訪業主',
        startTime: '請輸入開始時間',
        endTime: '請輸入結束時間'
      },
      list: {
        title: '訪客人員'
      },
      table: {
        visitId: '拜訪ID',
        name: '姓名',
        photo: '照片',

        gender: '性別',
        phoneNumber: '電話號碼',
        roomName: '拜訪房屋',
        ownerName: '拜訪業主',
        carNum: '訪客車輛',
        visitType: '訪客類型',
        visitCase: '拜訪事由',
        entourage: '隨行人數',
        visitTime: '拜訪時間',
        departureTime: '離開時間',
        state: '審核狀態',
        carStatus: '車輛狀態',

        msg: '審核備註',
        createTime: '創建時間'
      },
      gender: {
        male: '男',
        female: '女'
      },
      visitType: '訪客類型',
      manage: '管理'
    },
  }
}
